<template>
  <b-modal v-model="isShow">
    <template #modal-title>
      {{ $t('User Info') }}
    </template>
    <b-container fluid>
      <b-row class="mb-2">
        <b-col>{{ $t('Name') }} : </b-col>
        <b-col cols="9">{{ displayName }}</b-col>
      </b-row>
      <b-row class="mb-5">
        <b-col>{{ $t('Email') }} : </b-col>
        <b-col cols="9">{{ email }}</b-col>
      </b-row>
      <b-row class="mb-5" v-if="hasPassword">
        <b-col cols="9">
          {{ $t('Change Password.') }}
        </b-col>
        <b-col>
          <b-button size="sm" @click="changePassword">
            {{ $t('Change') }}
          </b-button>
        </b-col>
      </b-row>
      <b-row class="mb-1">
        <b-col cols="9">
          {{
            $t('Leave iFBlock Service. Delete saved projects. Can not restore.')
          }}
        </b-col>
        <b-col>
          <b-button variant="danger" size="sm" @click="leave">
            {{ $t('Leave') }}
          </b-button>
        </b-col>
      </b-row>
    </b-container>
    <template #modal-footer="{ ok }">
      <div class="w-100">
        <b-button variant="primary" size="sm" class="float-right" @click="ok">
          {{ $t('Close') }}
        </b-button>
      </div>
    </template>
  </b-modal>
</template>

<script>
import { mapState, mapMutations } from 'vuex'

export default {
  name: 'UserPopup',
  data() {
    return {
      isShow: false
    }
  },
  computed: {
    ...mapState(['userInfo', 'userPopupData']),
    displayName() {
      return _.get(this.userInfo, 'displayName')
    },
    email() {
      return _.get(this.userInfo, 'email')
    },
    hasPassword() {
      return _.get(this.userInfo, 'providerId') === 'password'
    }
  },
  methods: {
    ...mapMutations(['setPasswordPopupData', 'setLeavePopupData']),
    changePassword() {
      this.setPasswordPopupData({
        isShow: true
      })
      this.isShow = false
    },
    leave() {
      this.setLeavePopupData({
        isShow: true
      })
      this.isShow = false
    }
  },
  watch: {
    userPopupData() {
      if (this.userPopupData.isShow) {
        this.isShow = true
      }
    }
  }
}
</script>

<style scoped>
button.btn-primary {
  margin-right: 10px;
}
</style>
